import { uxServicePluginFactory } from '@/shared/services/UxService'
export default uxServicePluginFactory()
